import _ from 'lodash';
var contentCache = [];

var set = function set(unitKey, unitRevision, flatten, promise) {
  var foundCache = get(unitKey, unitRevision, flatten);

  if (foundCache.promise === undefined) {
    contentCache.push({
      unitKey: unitKey,
      unitRevision: unitRevision,
      flatten: flatten,
      promise: promise
    });
  }
};

var get = function get(unitKey, unitRevision, flatten) {
  var fromCache = _.find(contentCache, function (cache) {
    return cache.unitKey === unitKey && cache.unitRevision === unitRevision && cache.flatten === flatten;
  });

  return fromCache ? fromCache : {};
};

var remove = function remove(unitKey, unitRevision, flatten) {
  _.remove(contentCache, function (cache) {
    return cache.unitKey === unitKey && cache.unitRevision === unitRevision && cache.flatten === flatten;
  });
};

export default {
  set: set,
  get: get,
  remove: remove
};